<template>
    <div class="wrapper">
        <div class="animated fadeIn">
            <b-row>
                <b-col>
                    <b-card header="Basis gegevens">
                        <b-form @submit.prevent="saveUser">
                            <b-row>
                                <b-col cols="12" md="6">
                                    <b-form-group label="Naam">
                                        <b-form-input type="text" required v-model="user.name" :disabled="!editable"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="6">
                                    <b-form-group label="Email">
                                        <b-form-input type="text" required v-model="user.email" :disabled="!editable"></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="12" md="6">
                                    <b-form-group label="Type">
                                        <b-form-select
                                            :options="selectOptions"
                                            v-model="user.type"
                                            :disabled="!editable"
                                            required></b-form-select>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="12" md="6">
                                    <b-form-group label="Wachtwoord">
                                        <b-form-input type="password" v-model="user.password" :disabled="!editable"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="6">
                                    <b-form-group label="Wachtwoord bevestiging">
                                        <b-form-input type="password" v-model="user.password_confirmation" :disabled="!editable"></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <hr>
                                    <div v-if="editable">
                                        <b-button type="submit" variant="success" class="pull-right">Opslaan</b-button>
                                        <b-button @click="editable = false" class="pull-right mr-2"
                                                  variant="warning">
                                            Annuleren
                                        </b-button>
                                    </div>
                                    <div v-else>
                                        <b-button @click.prevent="editable = true" type="button" class="pull-right" variant="primary">
                                            Bewerken
                                        </b-button>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-form>
                    </b-card>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
    import {getData, updateData} from '../../api';

    export default {
        name: 'user-view',
        data() {
            return {
                user: {},
                editable: false,
                selectOptions: [
                    {value: 'admin', text: 'Admin'},
                    {value: 'super-admin', text: 'Super Admin'},
                ],
            }
        },
        methods: {
            saveUser() {
                this.editable = false;

                updateData(`users/${this.$route.params.id}`, this.user)
                    .then(({data}) => {
                        this.user = data.data;
                    });
            },
            async getUser() {
                const user = await getData('users/' + this.$route.params.id).then(response => response.data);
                this.user = user.data;
            }
        },
        beforeMount() {
            this.getUser();
        }
    }
</script>
